const NoPage = () => {
  return <h4 style={{color: '#EA6C82'}}>Error. The page you are trying to navigate to is not found</h4>;
};

export default NoPage;
